(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('userManagementService', UserManagementService);

    UserManagementService.$inject = ["$filter"];

    function UserManagementService($filter) {
        var self = this;

        self.DISPLAY_NAME_OPTIONS = {
            "KNOWN_AS_LAST_NAME": "KNOWN_AS_LAST_NAME",
            "FIRST_NAME_LAST_NAME": "FIRST_NAME_LAST_NAME"
        };

        const USER_STATUS = {
            TERMINATED: 'TERMINATED',
            ACTIVE: 'ACTIVE',
            INACTIVE: 'INACTIVE'
        };

        var getUserName = function (user, onlyFirstName) {
            return onlyFirstName ? user.first_name : [user.first_name, user.last_name].join(" ");
        };
        /**
         *
         * @param user
         * @param nameDisplayMode
         * @param onlyFirstName: show firstName or knownAs + lastName
         * @returns {string}
         */
        self.getUserDisplayName = function (user, nameDisplayMode, onlyFirstName) {
            var displayName;

            switch (nameDisplayMode) {
                case self.DISPLAY_NAME_OPTIONS.KNOWN_AS_LAST_NAME:
                    if (!user['known_as']) {
                        displayName = getUserName(user, onlyFirstName)
                    } else {
                        displayName = [user['known_as'], user.last_name].join(" ");
                    }
                    break;

                default:
                    displayName = getUserName(user, onlyFirstName);
            }

            return displayName;
        };

        var getLatestPeriod = function (userPeriods) {
            return userPeriods && userPeriods[userPeriods.length - 1];
        };

        self.prepareUserDetails = function (userDetails, settings) {
            var user = $.extend(userDetails, {});
            settings = settings || {};

            user.name = getUserName(user);
            user.display_name = self.getUserDisplayName(user, settings['employee_side_name_display_mode']);

            user.profileImageURL = $filter('hMediaURL')({
                uuid: user['profile_image'] && user['profile_image']['uuid'],
                path: user['profile_image'] && user['profile_image']['path']
            }, 'user_profile');

            var latestEmploymentPeriods = getLatestPeriod(user.employment_periods);

            if (latestEmploymentPeriods) {
                user.hire_date = latestEmploymentPeriods['hire_date'];
                user.leave_date = latestEmploymentPeriods['leave_date'];
                user.employment_type = latestEmploymentPeriods['employment_type'];
            }

            user.isTerminated = () => {
                return user.status === USER_STATUS.TERMINATED;
            };

            user.isTransferredOrUnshared = () => {
                return !user.is_scheduling_member && user.status !== USER_STATUS.TERMINATED;
            };

            user.isMinor = function (refDate) {
                return !!(user['birth_date'] && moment(refDate).diff(user['birth_date'], 'years') < 18);
            };

            user.isManager = function () {
                return user.types.indexOf('EMPLOYER') > -1;
            };

            user.isTeamLiveRegistered = () => user.is_team_live_registered;

            user.hasWorkVisa = function () {
                return user.is_work_visa_required;
            };

            user.isAnonymous = function () {
                return user.schedule_visibility === 'ANONYMOUS';
            };

            user.isVSLOptIn = function() {
                return !!(user.vsl && user.vsl.value === 'IN');
            };

            user.getUserAge = function (refDate) {
                return user['birth_date'] && moment(refDate).diff(user['birth_date'], 'years');
            };

            user.isNewlyHied = function (date, threshold) {
                var diff = moment(date).diff(user.hire_date, 'days');

                return diff >= 0 && diff < threshold;
            };

            user.getLatestLocationPeriod = function () {
                return getLatestPeriod(user.location_periods);
            };

            var getPositionDetails = function (positions, positionCode) {
                var position;

                if (positions && positions.length) {
                    position = positions.find(function (position) {
                        return position.code === positionCode;
                    });
                }

                return position;
            };

            user.getUserPositionEffectiveDate = function (positionCode) {
                var positionEffDate = '';
                var position = getPositionDetails(user['positions'], positionCode);
                positionEffDate = position && position.effective_date;

                return positionEffDate;
            };

            user.getUserPositionSkillLevel = function (positionCode, perCode) {
                var skillLevel = '';
                var position = getPositionDetails(user['positions'], positionCode);
                var positionSkillLevel = position && position['skill_level'];

                if (positionSkillLevel) {
                    skillLevel = perCode? positionSkillLevel['code']: positionSkillLevel['name'];
                }

                return skillLevel;
            };

            user.isAllPeriodLoa = function (selectedDate, viewType) {
                var isAllPeriodLoa = false;

                if (user.blocked_periods && user.blocked_periods.length) {
                    for (var i in user.blocked_periods) {
                        var blockedPeriod = user.blocked_periods[i];
                        var startDate = blockedPeriod.start_date;
                        var endDate = blockedPeriod.end_date || blockedPeriod.projected_end_date;
                        var formattedDate = moment(selectedDate).format("YYYY-MM-DD");
                        var formattedEndWeekDate;

                        if (viewType === 'WEEKLY') {
                            formattedEndWeekDate = moment(formattedDate).clone().add(7, 'days').format("YYYY-MM-DD");
                        }

                        if (blockedPeriod.type === 'LOA' &&
                            moment(formattedDate).isSameOrAfter(moment(startDate)) &&
                            (!endDate || (formattedEndWeekDate ? moment(formattedEndWeekDate).isSameOrBefore(moment(endDate)) : moment(formattedDate).isSameOrBefore(moment(endDate))))
                        ) {
                            isAllPeriodLoa = true;
                            break;
                        }
                    }
                }
                return isAllPeriodLoa;
            };

            user.hasEffectiveLOA = function (date, consider_projected_end_date) {
                var hasEffectiveLOA = false;
                var effectiveDate = date || new Date().toDateString();

                if (user.blocked_periods && user.blocked_periods.length) {
                    for (var i in user.blocked_periods) {
                        var blockedPeriod = user.blocked_periods[i];
                        var startDate = blockedPeriod.start_date;
                        var endDate = blockedPeriod.end_date;

                        if (!endDate && consider_projected_end_date) {
                            endDate = blockedPeriod.projected_end_date;
                        }

                        if (
                            blockedPeriod.type === 'LOA' &&
                            moment(effectiveDate).isSameOrAfter(moment(startDate)) &&
                            (!endDate || (moment(effectiveDate).isSameOrBefore(moment(endDate))))
                        ) {
                            hasEffectiveLOA = true;
                            break;
                        }
                    }
                }

                return hasEffectiveLOA;
            };

            user.hasEffectiveLOAPeriod = function(date, viewType) {
                var hasEffectiveLOA = false;

                if (user.blocked_periods && user.blocked_periods.length) {
                    for (var i in user.blocked_periods) {
                        var blockedPeriod = user.blocked_periods[i];
                        var startDate = blockedPeriod.start_date;
                        var endDate = blockedPeriod.end_date;
                        var selectedDate = date ? moment(date) : moment();

                        if (viewType === 'WEEKLY') {
                            var formattedEndWeekDate = moment(date).clone().add(7, 'days').format("YYYY-MM-DD");
                        }

                        if (
                            blockedPeriod.type === 'LOA' &&
                            (selectedDate.isSameOrAfter(startDate) || (formattedEndWeekDate && moment(formattedEndWeekDate).isSameOrAfter(startDate))) &&
                            (!endDate || (selectedDate.isSameOrBefore(endDate)))
                        ) {
                            hasEffectiveLOA = true;
                            break;
                        }
                    }
                }
                return hasEffectiveLOA;
            };

            user.hasEffectiveLactationPeriod = function(date, viewType) {
                var hasEffectiveLactationPeriod = false;
                if (user.lactation_break_periods && user.lactation_break_periods.length) {
                    for (var i in user.lactation_break_periods) {
                        var lactationPeriod = user.lactation_break_periods[i];
                        var startDate = lactationPeriod.start_date;
                        var endDate = lactationPeriod.end_date;
                        var selectedDate = date ? moment(date) : moment();

                        if (viewType === 'WEEKLY') {
                            var formattedEndWeekDate = moment(date).clone().add(7, 'days').format("YYYY-MM-DD");
                        }

                        if (
                            (selectedDate.isSameOrAfter(startDate) ||
                                (formattedEndWeekDate && moment(formattedEndWeekDate).isSameOrAfter(startDate)))  &&
                            (!endDate || (selectedDate.isSameOrBefore(endDate)))
                        ) {
                            hasEffectiveLactationPeriod = true;
                            break;
                        }
                    }
                }
                return hasEffectiveLactationPeriod;
            };

            user.getScheduledLocationPeriod = function (nowInBrandZone) {
                var scheduledPeriod;
                if (user.location_periods && user.location_periods.length) {

                    for (var i in user.location_periods) {
                        var locationStartDate = user.location_periods[i].start_date;

                        if (nowInBrandZone && locationStartDate && nowInBrandZone.isBefore(locationStartDate, 'day')) {
                            scheduledPeriod = user.location_periods[i];
                            break;
                        }
                    }
                }

                return scheduledPeriod;
            };

            user.isDateAfterHireDate = function (date) {
                if (user.employment_periods && user.employment_periods.length) {
                    var lastIndex = user.employment_periods.length - 1;
                    var hireDate = user.employment_periods[lastIndex].hire_date;
                    var formattedDate = moment(date).format("YYYY-MM-DD");

                    return hireDate && moment(formattedDate).isSameOrAfter(hireDate);
                } else {
                    return false;
                }
            };

            user.isDateBeforeLeaveDate = function (date) {
                if (user.employment_periods && user.employment_periods.length) {
                    var lastIndex = user.employment_periods.length - 1;
                    var leaveDate = user.employment_periods[lastIndex].leave_date;
                    var formattedDate = moment(date).format("YYYY-MM-DD");

                    return !leaveDate || moment(formattedDate).isSameOrBefore(leaveDate);
                } else {
                    return false;
                }
            };

            user.isInSharedLocation = function (date, viewType) {
                var isInSharedLocation = false;

                for (var i in user.location_periods) {
                    var locationPeriod = user.location_periods[i];
                    var startDate = locationPeriod.start_date;
                    var endDate = locationPeriod.end_date;
                    var formattedDate = moment(date).format("YYYY-MM-DD");

                    if (viewType === 'WEEKLY') {
                        var formattedEndWeekDate = moment(formattedDate).clone().add(7, 'days').format("YYYY-MM-DD");
                    }

                    if ((moment(formattedDate).isSameOrAfter(moment(startDate)) ||
                            (formattedEndWeekDate ? moment(startDate).isSameOrBefore(moment(formattedEndWeekDate)) : moment(startDate).isSameOrBefore(moment(formattedDate)))) &&
                        (!endDate || (moment(formattedDate).isSameOrBefore(moment(endDate)))) &&
                        locationPeriod.type == 'SECONDARY'
                    ) {
                        isInSharedLocation = true;
                        break;
                    }
                }

                return isInSharedLocation;
            };

            user.isDateWithinEmploymentPeriod = function (date, viewType) {
                var isDateWithinEmploymentPeriod = false;

                if (user.employment_periods && user.employment_periods.length) {
                    var formattedDate = moment(date).format("YYYY-MM-DD");

                    if (viewType === 'WEEKLY') {
                        var formattedEndWeekDate = moment(date).clone().add(7, 'days').format("YYYY-MM-DD");
                    }

                    for (var i in user.employment_periods) {
                        var employmentPeriod = user.employment_periods[i];
                        var hireDate = employmentPeriod.hire_date;
                        var leaveDate = employmentPeriod.leave_date;

                        if (
                            hireDate &&
                            (
                                moment(formattedDate).isSameOrAfter(hireDate) ||
                                (formattedEndWeekDate && moment(formattedEndWeekDate).isSameOrAfter(hireDate))
                            ) &&
                            (!leaveDate || moment(formattedDate).isSameOrBefore(leaveDate))
                        ) {
                            isDateWithinEmploymentPeriod = true;
                            break;
                        }
                    }
                }

                return isDateWithinEmploymentPeriod;
            };

            user.isTerminatedDateWithinPeriod = function (startDate, endDate) {
                if (!user.employment_periods || !user.employment_periods.length) {
                    return false;
                }

                for (var index = 0; index < user.employment_periods.length; index++) {
                    var employmentPeriod = user.employment_periods[index];
                    if (
                        employmentPeriod.leave_date &&
                        moment(employmentPeriod.leave_date).isSameOrAfter(moment(startDate, 'YYYY-MM-DD')) &&
                        moment(employmentPeriod.leave_date).isSameOrBefore(moment(endDate, 'YYYY-MM-DD'))
                    ) {
                        user.terminationDate = employmentPeriod.leave_date;
                        return true;
                    }
                }
                return false;
            };

            user.isDateWithinActiveLocationPeriod = function (date, viewType) {
                var isWithinActivePeriod = false;
                if (user.location_periods && user.location_periods.length) {
                    var formattedDate = moment(date).format("YYYY-MM-DD");
                    if (viewType === 'WEEKLY') {
                        var formattedEndWeekDate = moment(date).clone().add(7, 'days').format("YYYY-MM-DD");
                    }

                    for (var i in user.location_periods) {
                        var locationStartDate = user.location_periods[i].start_date;
                        var locationEndDate = user.location_periods[i].end_date;
                        var isSameOrAfterDay = moment(formattedDate).isSameOrAfter(locationStartDate);
                        var isSameOrAfterWeek = formattedEndWeekDate && moment(formattedEndWeekDate).isSameOrAfter(locationStartDate);
                        var isSameOrBeforeDay = !locationEndDate || moment(formattedDate).isSameOrBefore(locationEndDate);

                        if ((isSameOrAfterDay || isSameOrAfterWeek) && (isSameOrBeforeDay)) {
                            isWithinActivePeriod = true;
                            break;
                        }
                    }
                }

                return isWithinActivePeriod;
            };

            user.isDateWithinScheduledLocationPeriod = function (date, nowInBrandZone, viewType) {
                var isWithinScheduledPeriod = false;
                var scheduledLocation = user.getScheduledLocationPeriod(nowInBrandZone);

                if (user.location_periods && user.location_periods.length) {
                    var formattedDate = moment(date).format("YYYY-MM-DD");
                    if (viewType === 'WEEKLY') {
                        var formattedEndWeekDate = moment(date).clone().add(7, 'days').format("YYYY-MM-DD");
                    }

                    if (scheduledLocation &&
                        (
                            (moment(formattedDate).isSameOrAfter(scheduledLocation.start_date) ||
                                (formattedEndWeekDate && moment(formattedEndWeekDate).isSameOrAfter(scheduledLocation.start_date))) &&
                            (!scheduledLocation.end_date || moment(formattedDate).isSameOrBefore(scheduledLocation.end_date))
                        )
                    ) {
                        isWithinScheduledPeriod = true;
                    }
                }

                return isWithinScheduledPeriod;
            };

            user.isDateWithinActiveOrScheduledLocationPeriod = function (date, nowInBrandZone, viewType) {
                return (
                    user.isDateWithinActiveLocationPeriod(date, viewType) ||
                    user.isDateWithinScheduledLocationPeriod(date, nowInBrandZone, viewType)
                );
            };

            return user;
        };
    }
})();